module.exports = __webpack_public_path__ + "media/greenhouse-fullhd02.aacf7b49.mp4";